import { defineMessages } from 'react-intl';

const messages = defineMessages({
  viewEventsHeader: {
    id: 'collegeevents.events.view.header',
    defaultMessage: 'Events',
  },
  viewEventsHeaderCheckboxes: {
    id: 'collegeevents.events.view.header.checkboxes',
    defaultMessage: 'View events for:',
  },
  viewEventsCamino: {
    id: 'collegeevents.events.view.camino',
    defaultMessage: 'Camino',
  },
  viewEventsNaviance: {
    id: 'collegeevents.events.view.naviance',
    defaultMessage: 'Naviance',
  },
  viewEventsCaminoNaviance: {
    id: 'collegeevents.events.view.caminonaviance',
    defaultMessage: 'Naviance & Camino',
  },
  viewEventsPublished: {
    textComponent: 'h2',
    id: 'collegeevents.events.view.published',
    defaultMessage: 'Published ({published})',
  },
  viewEventsUnpublished: {
    textComponent: 'h2',
    id: 'collegeevents.events.view.unpublished',
    defaultMessage: 'Unpublished ({drafts})',
  },
  viewEventsExpired: {
    textComponent: 'h2',
    id: 'collegeevents.events.view.expired',
    defaultMessage: 'Expired ({expired})',
  },
  viewEventsCreateEvent: {
    id: 'collegeevents.events.view.create.event',
    defaultMessage: 'CREATE EVENT',
  },
  viewEventsCreateEventNew: {
    id: 'collegeevents.events.view.create.event.new',
    defaultMessage: 'CREATE EVENT',
  },
  viewEventsEmptyTitlePublished: {
    id: 'collegeevents.events.view.empty.head.published',
    defaultMessage: 'Published Events',
  },
  viewEventsEmptyTextPublished: {
    id: 'collegeevents.events.view.empty.text.published',
    defaultMessage: 'When you publish an event for students they will be listed here for you to manage.',
  },
  viewEventsEmptyTitleUnpublished: {
    id: 'collegeevents.events.view.empty.head.unpublished',
    defaultMessage: 'Unpublished Events',
  },
  viewEventsEmptyTextUnpublished: {
    id: 'collegeevents.events.view.empty.text.unpublished',
    defaultMessage: 'Created events that are not published will be displayed here to manage.',
  },
  viewEventsEmptyTitleExpired: {
    id: 'collegeevents.events.view.empty.head.expired',
    defaultMessage: 'Expired Events',
  },
  viewEventsEmptyTextExpired: {
    id: 'collegeevents.events.view.empty.text.expired',
    defaultMessage:
      'Past events will be listed here. You will have the option to duplicate any event to expedite creating a future event.',
  },
  locationVirtualEvent: {
    id: 'collegeevents.location.virtualEvent',
    defaultMessage: 'Virtual Event',
  },
  viewEventsEditEvent: {
    id: 'collegeevents.events.view.edit.event',
    defaultMessage: 'Edit',
  },
  viewEventsUnpublishEvent: {
    id: 'collegeevents.events.view.unpublish.event',
    defaultMessage: 'Unpublish',
  },
  viewEventsPublishEvent: {
    id: 'collegeevents.events.view.publish.event',
    defaultMessage: 'Publish',
  },
  viewEventsDeleteEvent: {
    id: 'collegeevents.events.view.delete.event',
    defaultMessage: 'Delete',
  },
  viewEventsDuplicateEvent: {
    id: 'collegeevents.events.view.duplicate.event',
    defaultMessage: 'Duplicate',
  },
  viewEventOptions: {
    id: 'collegeevents.events.event.options',
    defaultMessage: 'Event options',
  },
  no: {
    id: 'collegeevents.events.view.confirmNo',
    defaultMessage: 'No',
  },
  yes: {
    id: 'collegeevents.events.view.confirmYes',
    defaultMessage: 'Yes',
  },
  ok: {
    id: 'collegeevents.events.view.confirmOK',
    defaultMessage: 'OK',
  },
  actionConfirmMessagePre: {
    id: 'collegeevents.events.action.confirmMessagePre',
    defaultMessage: 'Are you sure you want to change the status of this event to',
  },
  actionConfirmMessagePost: {
    id: 'collegeevents.events.action.confirmMessagePost',
    defaultMessage: '?',
  },
  toastPublishedTitle: {
    id: 'collegeevents.events.toast.published.title',
    defaultMessage: 'Event Published!',
  },
  toastPublishedSubtitle: {
    id: 'collegeevents.events.toast.published.subtitle',
    defaultMessage: 'has been published.',
  },
  toastDraftedTitle: {
    id: 'collegeevents.events.toast.drafted.title',
    defaultMessage: 'Draft Saved!',
  },
  toastDraftedSubtitle: {
    id: 'collegeevents.events.toast.drafted.subtitle',
    defaultMessage: 'has been saved as a draft.',
  },
  toastUnpublishedTitle: {
    id: 'collegeevents.events.toast.unpublished.title',
    defaultMessage: 'Event Unpublished!',
  },
  toastUnpublishedSubtitle: {
    id: 'collegeevents.events.toast.unpublished.subtitle',
    defaultMessage: 'has been unpublished.',
  },
  deleteModalTitle: {
    id: 'collegeevents.events.delete.modal.title',
    defaultMessage: 'Are you sure you want to delete this event?',
  },
  deleteModalSubtitle: {
    id: 'collegeevents.events.delete.modal.subtitle',
    defaultMessage: 'This will permanently delete all details associated with this event\nand will no longer appear to students.',
  },
  deleteModalAction: {
    id: 'collegeevents.events.delete.modal.action',
    defaultMessage: 'Delete',
  },
  deleteModalReject: {
    id: 'collegeevents.events.delete.modal.reject',
    defaultMessage: 'Cancel',
  },
  exportAttendees: {
    id: 'collegeevents.events.export.attendees',
    defaultMessage: 'EXPORT ATTENDEES',
  },
  exportAttendeesTooltipMessage: {
    id: 'collegeevents.events.export.attendees.tooltip',
    defaultMessage: 'For a limited time, export attendee lists from prior events here. For all newly created events, attendee information is captured through the registration links you provide.',
  },
});

export default messages;
